// Copyright 2018 The MathWorks, Inc.

define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "MW/uiframework/contextmanager/FeatureManager"
], function (declare, lang, FeatureManager) {
    return declare([FeatureManager], {

        /**
         * @param args {{contextManagerImpl: ContextManager, uiContainer: UIContainer}}
         */
        constructor: function (args) {
            this._uiContainer = args.uiContainer;
            this._registeredComponents = {};
            this._currentComponentTags = [];
        },

        /**
         * @param args {appId: string, contextId: string, componentTags: [string]}
         */
        registerComponents: function (args) {
            if (!this._registeredComponents[args.appId]) {
                this._registeredComponents[args.appId] = {};
            }

            if (!this._registeredComponents[args.appId][args.contextId]) {
                this._registeredComponents[args.appId][args.contextId] = {};
            }

            if (args.statusComponentTags) {
                this._registeredComponents[args.appId][args.contextId].componentTags = args.statusComponentTags;
            }
        },

        /**
         * @param args {appId: string, contextId: string}
         */
        unregisterComponents: function (args) {
            if (this._registeredComponents[args.appId]) {
                if (this._registeredComponents[args.appId][args.contextId]) {
                    delete this._registeredComponents[args.appId][args.contextId];
                } else {
                    delete this._registeredComponents[args.appId];
                }
            }
        },

        _update: function (context, secondaryContext) {
            if (!(this._uiContainer && this._uiContainer.statusBarId)) {
                return;
            }
            var that = this;
            var uiBuilder = this._uiContainer.uiBuilder;

            // Get the list of status components associated with the new contexts
            var contextualComponentTags = this._getComponentTagsForContext(context);
            var secondaryComponentTags = this._getComponentTagsForContext(secondaryContext);
            contextualComponentTags = contextualComponentTags.concat(secondaryComponentTags);

            // Remove any components associated with the old context that are not relevant to the new context
            this._currentComponentTags.forEach(function (tag) {
                if (contextualComponentTags.indexOf(tag) < 0) {
                    uiBuilder.remove(uiBuilder.tagToId(tag));
                }
            });

            // Add components associated with the new context that aren't already present
            contextualComponentTags.forEach(function (tag) {
                if (that._currentComponentTags.indexOf(tag) < 0) {
                    uiBuilder.add(uiBuilder.tagToId(tag), that._uiContainer.statusBarId);
                }
            });

            this._lastContext = context;
            this._currentComponentTags = contextualComponentTags;
        },

        _getComponentTagsForContext: function (context) {
            var componentTags = [];
            if (context && context.contextIdList && this._registeredComponents[context.appId]) {
                context.contextIdList.forEach(function (contextId) {
                    if (this._registeredComponents[context.appId][contextId]) {
                        var tags = this._registeredComponents[context.appId][contextId].componentTags;
                        if (tags) {
                            componentTags = componentTags.concat(tags);
                        }
                    }
                }, this);
            }
            return componentTags;
        }
    });
});